export default __webpack_public_path__ + "static/media/IconDesc_ConveyorPole.256.9f1b05db.png";